import { END_POINTS } from "../helpers";
import { CommonBody, OtpResponse, Users } from "../types/General";
import { User } from "../types/User";
import emptySplitApi from "../utils/rtk";

type CommonResponseType = {
  statusCode: number;
  data?: User;
  message: string;
};

type PostForgotPasswordResponse = {
  statusCode: number;
  data?: User;
  message: string;
};

type PostResetPasswordResponse = {
  statusCode: number;
  data?: any;
  message: string;
};

type PostChangePasswordResponse = {
  statusCode: number;
  data?: any;
  message: string;
};

type GetProfileResponse = {
  statusCode: number;
  code?: number;
  data?: any;
};

type CommonResponse = {
  statusCode: number;
  message?: string;
  data?: any;
};

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postVerifyOtp: builder.mutation<CommonResponse & { data: any }, any>({
      query: (body) => ({
        url: END_POINTS.verifyOtp,
        method: "POST",
        body,
      }),
    }),
    postLogin: builder.mutation<CommonResponseType, any>({
      query: (body) => ({
        url: END_POINTS.login,
        method: "POST",
        body,
      }),
    }),

    sendOtp: builder.mutation<PostForgotPasswordResponse, any>({
      query: (body) => ({
        url: END_POINTS.sendOtp,
        method: "POST",
        body,
      }),
    }),

    postForgotPassword: builder.mutation<PostForgotPasswordResponse, any>({
      query: (body) => ({
        url: END_POINTS.forgotPassword,
        method: "POST",
        body,
      }),
    }),
    updateProfile: builder.mutation<CommonResponse & { data: any }, any>({
      query: (body) => ({
        url: END_POINTS.updateProfile,
        method: "POST",
        body,
      }),
    }),

    editMyProfile: builder.mutation<CommonResponse & { data: any }, any>({
      query: (body) => ({
        url: END_POINTS.editMyProfile,
        method: "PUT",
        body,
      }),
    }),

    postResetPassword: builder.mutation<PostResetPasswordResponse, any>({
      query: (body) => ({
        url: END_POINTS.resetPassword,
        method: "POST",
        body,
      }),
    }),
    postChangePassword: builder.mutation<PostChangePasswordResponse, any>({
      query: (body) => ({
        url: END_POINTS.changePassword,
        method: "POST",
        body,
      }),
    }),
    getProfile: builder.query<GetProfileResponse, { id: string | undefined }>({
      query: ({ id }) => ({
        url: `${END_POINTS.getProfile}/${id}`,
        method: "GET",
      }),
    }),

    myProfile: builder.query<GetProfileResponse, {}>({
      query: ({}) => ({
        url: `${END_POINTS.myProfile}`,
        method: "GET",
      }),
    }),

    logoutApi: builder.query<CommonResponse, {}>({
      query: () => ({
        url: END_POINTS.logout,
        method: "GET",
      }),
    }),
  }),
});

export const {
  usePostLoginMutation,
  usePostVerifyOtpMutation,
  usePostForgotPasswordMutation,
  usePostResetPasswordMutation,
  usePostChangePasswordMutation,
  useLazyGetProfileQuery,
  useLazyLogoutApiQuery,
  useUpdateProfileMutation,
  useLazyMyProfileQuery,
  useEditMyProfileMutation,
  useSendOtpMutation,
} = authApi;
